import "./pdfjsWorkerSetup";

// The only sanctioned entry point to pdfjs-dist, enforced by the
// no-restricted-imports rule in .oxlintrc.json: importing pdfjs through this
// facade guarantees the worker URL is registered before any pdfjs API can run,
// regardless of chunk load order. Type-only imports from pdfjs-dist/types/*
// are allowed directly since they are erased at compile time.
export { AnnotationMode, getDocument, PDFWorker } from "pdfjs-dist";
export type {
    PDFDocumentProxy,
    PDFOperatorList,
    PDFPageProxy,
    RenderParameters,
} from "pdfjs-dist/types/src/display/api";
